import React, { useState } from 'react';
import { useNotify, useRefresh, useRecordContext } from 'react-admin';
import { Button } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import {
  MAX_FEATURED_VENUES,
  toggleFeaturedVenue,
} from '../../services/featuredVenuesService';

const FeaturedVenueButton = ({ featuredIds, onFeaturedChange }) => {
  const record = useRecordContext();
  const notify = useNotify();
  const refresh = useRefresh();
  const [busy, setBusy] = useState(false);

  if (!record?.id) return null;

  const isFeatured = featuredIds.includes(record.id);

  const onClick = async (e) => {
    e.stopPropagation();
    if (busy) return;
    if (!isFeatured && featuredIds.length >= MAX_FEATURED_VENUES) {
      notify(`En fazla ${MAX_FEATURED_VENUES} mekan öne çıkarılabilir`, {
        type: 'warning',
      });
      return;
    }
    setBusy(true);
    try {
      const next = await toggleFeaturedVenue(record.id, isFeatured, featuredIds);
      onFeaturedChange?.(next);
      notify(
        isFeatured ? 'Öne çıkarmadan kaldırıldı' : 'Öne çıkanlara eklendi',
        { type: 'info' },
      );
      refresh();
    } catch (err) {
      notify(err?.message || 'İşlem başarısız', { type: 'error' });
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button
      size="small"
      onClick={onClick}
      disabled={busy}
      startIcon={isFeatured ? <StarIcon /> : <StarBorderIcon />}
      color={isFeatured ? 'warning' : 'inherit'}
      variant={isFeatured ? 'contained' : 'outlined'}
      sx={{ fontSize: 11, whiteSpace: 'nowrap' }}
    >
      {isFeatured ? 'Öne Çıkan' : 'Öne Çıkar'}
    </Button>
  );
};

export default FeaturedVenueButton;
